// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1A237E", // Deep Indigo – Trustworthy & Professional
        },
        secondary: {
            main: "#FF6F00", // Warm Amber – Energetic & Creative
        },
        background: {
            default: "#f4f6f8", // Light neutral background
            paper: "#ffffff",   // Clean white for cards/panels
        },
        text: {
            primary: "#212121",
            secondary: "#616161",
        },
    },
    typography: {
        fontFamily: "'Poppins', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
        h1: {
            fontWeight: 700,
            fontSize: '3rem',
        },
        h2: {
            fontWeight: 600,
            fontSize: '2.5rem',
        },
        h3: {
            fontWeight: 500,
            fontSize: '2rem',
        },
        body1: {
            fontSize: '1rem',
        },
        body2: {
            fontSize: '0.875rem',
            color: "#555",
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#f4f6f8",
                    margin: 0,
                    padding: 0,
                },
                '.slick-slide > div': {
                    height: '100%',
                },
                '*': {
                    boxSizing: 'border-box',
                },
            },
        },
    },
});

export default theme;
